(function () {
  'use strict';

  angular
    .module('uos')
    .factory('UoParceira', UoParceiraService);

  function UoParceiraService(Restangular) {
    return Restangular.service('/auth/uo-parceira');
  }
}());
